import { Box, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { colors } from '../../util/colors'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'

const statisticsData = [
  {
    id: 0,
    icon: 'ARROWS',
    title: '2 Million+',
    subTitle: 'API requests per day',
  },
  {
    id: 1,
    icon: 'SHOP',
    title: '100K+',
    subTitle: 'Merchants trust us',
  },
  {
    id: 2,
    icon: 'FUND_TRANSFER',
    title: '300 Million+',
    subTitle: 'Transactions processed',
  },
  {
    id: 3,
    icon: 'MOBILE_CARD',
    title: '100+',
    subTitle: 'Payment methods supported',
  },
]

const StatisticContent = (isMobile, textSize) => {
  return statisticsData.map((item: any) => {
    return (
      <Box align={'center'} justify={'flex-start'}>
        <Icon id={item.icon} color={'WHITE'} size={48} />
        <Spacer size={isMobile ? 24 : 32} />
        <Text title={item.title} color={'WHITE'} fontFamily={'jiotype-black'} fontSize={isMobile ? 18 : 32} />
        <Spacer size={8} />
        <Text
          title={item.subTitle}
          color={'WHITE'}
          fontFamily={'jiotype-medium'}
          fontSize={textSize}
          opacity={0.7}
          textAlign={'center'}
          numberOfLines={1}
        />
      </Box>
    )
  })
}

export const StatisticsHome = ({ isMobile }: any) => {
  const resPadding = usePadding()
  const { textSize } = useFontSize()

  return (
    <Box
      pt={isMobile ? 90 : 120}
      pb={240}
      ph={resPadding}
      flexDirection={isMobile ? 'column' : 'row'}
      gap={isMobile ? 64 : undefined}
      marginTop={isMobile ? -100 : -260}
      justify={'space-between'}
      bg={colors.JIO_PRIMARY_ALPHA as ColorOptions}
      borderTopRightRadius={isMobile ? 32 : 120}
      borderTopLeftRadius={isMobile ? 32 : 120}>
      {StatisticContent(isMobile, textSize)}
    </Box>
  )
}
